import { Routes } from '@angular/router'
import { LoginPageComponent } from './pages/login/login.component'
import { NotFoundPageComponent } from './pages/errors/not-found/not-found.component'
import { redirectByRoleGuard } from './auth/redirect-by-role.guard'
import { loginGuard } from './auth/login.guard'
import { LoginCallbackComponent } from './pages/login/login-callback/login-callback.component'

export const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [redirectByRoleGuard],
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [loginGuard],
  },
  { path: 'login/callback', component: LoginCallbackComponent },
  {
    path: 'mandatary',
    loadChildren: () =>
      import('./pages/mandatary/mandatary.routes').then(
        (m) => m.mandataryRoutes,
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.routes').then((m) => m.adminRoutes),
  },
  { path: '**', component: NotFoundPageComponent },
]
